



























































































import Vue from 'vue'
import { State, Action, Getter } from "vuex-class";
import { Component, Prop, Watch } from "vue-property-decorator";
import DateComponent from '@/components/common/Inputs/Date.vue';
import FormattedNumber from '@/components/common/Inputs/FormattedNumber.vue';
import VCurrencyField from "@/components/common/CurrencyInput/VCurrencyField.vue";
import { Utilities as utils } from "@/shared/utilities";
import { StatementOfExpenditure, IStatementOfExpenditure, FinancialReportData, FinReportConsolidation } from '@/entities';
import { Locales } from "@/i18n/locales";
const namespace: string = "financialReport";

@Component({
    components: {
        DateComponent,
        FormattedNumber,
        VCurrencyField
    }
})
export default class DetailedListingTable extends Vue {
    @State(namespace) financialReport!: FinancialReportData;
    @Prop() header: any;
    @Prop() items: Array<StatementOfExpenditure>;
    @Prop() currencyList: any;
    @Prop() grantInfo: any;
    @Prop() categories: Array<any>;
    @Prop() consolidation: FinReportConsolidation;
    @Prop() currency: string;
    @Prop() formOptions: any;
    defaultLocale: string = localStorage.getItem("language") || Locales.EN;

    searchString = '';

    get minDate() {
        if (this.grantInfo && this.grantInfo.StartDate && this.grantInfo.AgreementDate) 
            return utils.getMinDate(this.grantInfo.AgreementDate, this.grantInfo.StartDate).split('T')[0];
    }

    get dictCategory() {
        return this.categories.reduce((obj, catg) => {
            obj[catg.id] = catg.name;
            return obj;
        }, {});
    }

    get maxDate() {
        return new Date().toISOString().split('T')[0];
    }

    // get previous periods
    get previousPeriods() {
        return this.financialReport.finReports
        .filter(x => x.StartDate  < this.financialReport.selectedReport.StartDate);
    }

    /** calculate formulas */
    aggregate() {
        this.consolidation.forecast = this.items.map(x => x.forecast).reduce((a, b) => a + b || 0, 0);
        this.consolidation.replenishAmount = (this.consolidation.forecast ?? 0) - this.consolidation.balance;
        this.$emit('input', true);
    }
    
    /** get the preious period data */
    getPreviousPeriodData(periodId: number, categoryId: number) {
        if(this.financialReport.grantData.finReport){
            var report = this.financialReport.grantData.finReport.find(x => x.FinancialReportId == periodId);
            if(report && report.statementOfExpeditures) {
                var statement = report.statementOfExpeditures.find(x => x.categoryId == categoryId);
                if(statement)
                    return statement.currentExpenditure;
            }
        }
    }

    calPreviousPeriodDataTotal(periodId: number) {
        let totalPrevTotal: number = 0;

        if(this.financialReport.grantData.finReport) {
            var report = this.financialReport.grantData.finReport.find(x => x.FinancialReportId == periodId);

            if (report && report.statementOfExpeditures) {
                report.statementOfExpeditures.forEach((x) => {
                    totalPrevTotal = totalPrevTotal + x.currentExpenditure;
                });
            }
        }

        return totalPrevTotal;
    }
}
